import { render, staticRenderFns } from "./DataTableV2ItemEdit.html?vue&type=template&id=1c5cbf15&scoped=true&external"
import script from "./DataTableV2ItemEdit.js?vue&type=script&lang=js&external"
export * from "./DataTableV2ItemEdit.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2ItemEdit.css?vue&type=style&index=0&id=1c5cbf15&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5cbf15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VBtn,VCard})
